﻿import GroTranslator from './translator';

$(function () {
    Redestination.init();
    $(".massredestination-datepicker-default").each(function() {
        var $input = $(this);

        // Set initial value for massredestinationFromDate if empty
        if ($input.is("#massredestinationFromDate") && !$input.val()) {
            var today = new Date();
            var sevenDaysFromNow = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
            var formattedDate = $.datepicker.formatDate('yy-mm-dd', sevenDaysFromNow);
            $input.val(formattedDate);
        }
        if ($input.is("#massredestinationToDate") && !$input.val()) {
            var today = new Date();
            var sevenDaysFromNow = new Date(today.getTime() + (7 * 24 * 60 * 60 * 1000));
            var formattedDate = $.datepicker.formatDate('yy-mm-dd', sevenDaysFromNow);
            $input.val(formattedDate);
        }

        $input.datepicker({
            monthNames: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
            dayNamesMin: ["Sö", "Må", "Ti", "On", "To", "Fr", "Lö"],
            firstDay: 1,
            dateFormat: "yy-mm-dd",
            onSelect: function(dateText) {
                // When massredestinationFromDate changes, check massredestinationToDate
                if ($input.is("#massredestinationFromDate")) {
                    var $toDate = $("#massredestinationToDate");
                    var toDateValue = $toDate.val();

                    if (toDateValue) {
                        var fromDate = new Date(dateText);
                        var toDate = new Date(toDateValue);

                        // If toDate is before fromDate, set toDate to fromDate
                        if (toDate < fromDate) {
                            $toDate.val(dateText);
                        }
                    }
                }
            }
        });
    }).on("change", function () {
        var $this = $(this);
        var validDate = !/Invalid|NaN/.test(new Date($this.val()).toString());
        var validDateRegex = /^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])$/ig.test($this.val());

        if (!validDateRegex || !validDate) {
            $this.next().show();
        } else {
            $this.next().hide();
        }

        // Handle manual input changes for massredestinationFromDate
        if ($this.is("#massredestinationFromDate") && validDate && validDateRegex) {
            var $toDate = $("#massredestinationToDate");
            var toDateValue = $toDate.val();

            if (toDateValue) {
                var fromDate = new Date($this.val());
                var toDate = new Date(toDateValue);

                // If toDate is before fromDate, set toDate to fromDate
                if (toDate < fromDate) {
                    $toDate.val($this.val());
                }
            }
        }
    });
});

var Redestination = Redestination || (function () {
    function showSpinner() {
        $('#redestination-loader').fadeIn(200);
    }

    function hideSpinner() {
        $('#redestination-loader').fadeOut(200);
    }

    function addValidation() {
        $("#Massomform").validate({
            rules: {
                "SearchInput.WareHouseNumber": {
                    required: true
                },
                "SearchInput.ConfirmedDeliveryDateFrom": {
                    required: true
                },
                "SearchInput.ConfirmedDeliveryDateTom": {
                    required: true
                }
            },
            messages: {
                "SearchInput.WareHouseNumber": {
                    required: GroTranslator.get('/redestination/validation-error/warehouselocation'),
                },
                "SearchInput.ConfirmedDeliveryDateFrom": {
                    required: GroTranslator.get('/redestination/validation-error/deliverydatefrom'),
                },
                "SearchInput.ConfirmedDeliveryDateTom": {
                    required: GroTranslator.get('/redestination/validation-error/deliverydateto'),
                },

            },
            highlight: function (element) {
                $('#errors-list').show();
                $(element).addClass('error');

            },
            unhighlight: function(element) {
                $(element).removeClass('error');
            }
        });

        $('#ReDestinationSearch').on('click',
            function () {
                if (!$("#Massomform").valid()) {
                    return false;
                }
            });

        $("#reDestinationStepOne").validate({
            rules: {
                "DeliveryAssuranceForApproval.WareHouse": {
                    required: true
                },
                "DeliveryAssuranceForApproval.DeliveryDate": {
                    required: true
                },
                "DeliveryAssuranceForApproval.LorryType": {
                    required: true
                },

            },
            messages: {
                "DeliveryAssuranceForApproval.WareHouse": {
                    required: GroTranslator.get('/redestination/validation-error/warehouselocation'),
                },
                "DeliveryAssuranceForApproval.DeliveryDate": {
                    required: GroTranslator.get('/redestination/validation-error/deliveryDate'),
                },
                "DeliveryAssuranceForApproval.LorryType": {
                    required: GroTranslator.get('/redestination/validation-error/deliverymethod'),
                },

            },
            highlight: function (element) {
                $(element).addClass('error');

            },
            unhighlight: function(element) {
                $(element).removeClass('error');
            }
        });

        $('#reDestinationNext').on('click',
            function () {
                if (!$("#reDestinationStepOne").valid()) {
                    return false;
                }
            });
    }

    function addButtonEvents() {
        $('#massredestination-send-button').on('click', function () {
            var btn = $(this);
            showSpinner();
            setTimeout(function() {
                btn.prop('disabled', true);
                $('#massredestination-change-button').prop('disabled', true);
            }, 0);
        });

        $('#massredestination-change-button').on('click', function () {
            showSpinner();
        });

        const searchForm = document.getElementById('searchform');

        if (!searchForm) {
            return;
        }

        var parsedMaxSelected = parseInt(searchForm.dataset.maxSelected, 10);
        var maxSelected = Number.isNaN(parsedMaxSelected) ? 100 : parsedMaxSelected;
        var tbody = searchForm.querySelector('tbody');

        function getCheckboxes() {
            return tbody.querySelectorAll('input[type="checkbox"][name*="IsSelected"]');
        }

        function updateSelectionState() {
            var checkboxes = getCheckboxes();
            var checkedCount = 0;
            checkboxes.forEach(function (checkbox) {
                if (checkbox.checked) {
                    checkedCount++;
                }
            });

            // Only over the cap (not merely at it) blocks continuing, so exactly maxSelected stays submittable
            var overLimit = checkedCount > maxSelected;
            checkboxes.forEach(function (checkbox) {
                if (!checkbox.checked) {
                    checkbox.disabled = overLimit;
                }
            });

            $('#js-selected-count').text(checkedCount);
            $('#js-max-selection-warning').toggle(overLimit);
            $('#js-searchform-submit').prop('disabled', overLimit);

            return checkedCount;
        }

        tbody.addEventListener('change', function (e) {
            if (e.target.matches('input[type="checkbox"][name*="IsSelected"]')) {
                updateSelectionState();
            }
        });

        // Make the whole row clickable for selection
        tbody.addEventListener('click', function (e) {
            if (e.target.matches('input[type="checkbox"][name*="IsSelected"]')) {
                return;
            }

            var row = e.target.closest('tr');
            if (!row) {
                return;
            }

            var checkbox = row.querySelector('input[type="checkbox"][name*="IsSelected"]');
            if (!checkbox || checkbox.disabled) {
                return;
            }

            checkbox.checked = !checkbox.checked;
            updateSelectionState();
        });

        $(".js-select-all").click(function () {
            getCheckboxes().forEach(function (checkbox) {
                checkbox.checked = true;
            });
            updateSelectionState();
        });

        $(".js-deselect-all").click(function () {
            getCheckboxes().forEach(function (checkbox) {
                checkbox.checked = false;
                checkbox.disabled = false;
            });
            updateSelectionState();
        });

        searchForm.addEventListener('submit', function(e) {
            e.preventDefault();

        var selectedRows = [];
        var checkboxes = tbody.querySelectorAll('input[type="checkbox"][name*="IsSelected"]');
        checkboxes.forEach(function(checkbox) {
            if (checkbox.checked) {
                selectedRows.push(checkbox.closest('tr'));
            }
        });

        if (selectedRows.length === 0) {
            return;
        }

        if (selectedRows.length > maxSelected) {
            updateSelectionState();
            return;
        }

        // create a new temp form
        var tempForm = document.createElement('form');
        tempForm.action = this.action;
        tempForm.method = this.method;
        tempForm.style.display = 'none';

            // Copy CurrentPageId
            var currentPageIdInput = this.querySelector('input[name="CurrentPageId"]');
            if (currentPageIdInput) {
                tempForm.appendChild(currentPageIdInput.cloneNode());
            }

        selectedRows.forEach(function(row, newIdx) {
            var inputs = row.querySelectorAll('input');
            inputs.forEach(function(input) {

                var clone = input.cloneNode();
                clone.name = clone.name.replace(/\[\d+\]/, '[' + newIdx + ']');
                tempForm.appendChild(clone);
            });
        });

        document.body.appendChild(tempForm);
        tempForm.submit();
        });

        // Reflect pre-checked rows (e.g. redisplay after the server-side max-selection guard)
        updateSelectionState();
    }

    var init = function () {
        addButtonEvents();
        addValidation();
    };

    return {
        init: init,
        showSpinner: showSpinner,
        hideSpinner: hideSpinner
    };
})();
